import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as machineActions from 'app/actions/machines';
import * as fromRouter from 'app/reducers/router';
import { SharedModule } from 'app/modules/shared.module';
import { RouterOutlet } from '@angular/router';

@Component({
    imports: [SharedModule, RouterOutlet],
    templateUrl: 'machine-layout.component.html',
    styleUrls: ['./machine-layout.component.scss']
})
export class MachineLayoutComponent implements OnInit, OnDestroy {
  private store: Store = inject(Store);

  subscription: Subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(fromRouter.getMachineId).subscribe((id: string | null) => {
        if (id) {
          this.store.dispatch(machineActions.activateMachine({ id }));
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
